import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import api from '../../../services/api';
import {
  TextField,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Dialog,
  CircularProgress,
  IconButton,
} from '@material-ui/core';
import ImageIcon from '@material-ui/icons/Image';
import SendIcon from '@material-ui/icons/Send';
import GetAppIcon from '@material-ui/icons/GetApp';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {
  AccessTime,
  Check,
  DoneAll,
  ErrorOutline,
} from '@material-ui/icons';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { getConfigField } from 'lib/configUtils';
import {
  ASIM,
  DIRECAO_MSG_CHAT_ENVIADA,
  TIPO_MSG_CHAT_DOCUMENTO,
  TIPO_MSG_CHAT_IMAGEM,
  TIPO_MSG_CHAT_TEXTO,
  STATUS_MSG_CHAT_ENVIANDO,
  STATUS_MSG_CHAT_ENVIADA,
  STATUS_MSG_CHAT_RECEBIDA,
  STATUS_MSG_CHAT_LIDA,
  STATUS_MSG_CHAT_ERRO,
  WEBSOCKETURL,
  DIRECAO_MSG_CHAT_RECEBIDA
} from 'consts';

const styles = (theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    width: '100%',
  },

  conversations: {
    width: 320,
    minWidth: 320,
    flexShrink: 0,
    borderRight: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',

    [theme.breakpoints.down('sm')]: {
      width: 64,
      minWidth: 64,
    },
  },

  conversationsHeader: {
    padding: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  conversationsHeaderTitulo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  conversationsList: {
    flexGrow: 1,
    overflowY: 'auto',
    border: 'none',
  },

  conversationItem: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },

  chatContainer: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f5f5',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  chatContainerConversasExpandidas: {
    [theme.breakpoints.down('xs')]: {
      opacity: 0.55,
    },
  },

  chatHeader: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderBottom: '1px solid #ddd',
  },

  messagesArea: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflowY: 'auto',
    position: 'relative'
  },

  inputArea: {
    display: 'flex',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderTop: '1px solid #ddd',
  },

  messageReceived: {
    display: 'flex',
    justifyContent: 'flex-start',
    minWidth: 0,
    width: '100%',
    marginBottom: theme.spacing(0.5),
  },

  messageSent: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(0.5),
  },

  messageBubble: {
    maxWidth: '70%',
    minWidth: 0,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    backgroundColor: '#fff',
  },

  messageBubbleSent: {
    maxWidth: '70%',
    width: 'fit-content',
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 8,
    backgroundColor: '#dcf8c6',
  },

  messageText: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    fontSize: 14,
  },

  messageDate: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  messageDateText: {
    backgroundColor: '#e5e5e5',
    padding: '4px 12px',
    borderRadius: 12,
    fontSize: 12,
    color: '#555',
  },

  messageTime: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 8,
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
    fontSize: 11,
    color: '#777',
    float: 'right',
    height: 18,
    position: 'relative',
    top: 8,
  },

  conversationContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },

  conversationText: {
    flexGrow: 1,
    minWidth: 0,

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  unreadBadge: {
    minWidth: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#25D366',
    color: '#fff',
    fontSize: 11,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 6px',
    marginLeft: theme.spacing(1),

    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: -5,
      right: -7,
      marginLeft: 0,
      minWidth: 14,
      height: 14,
      padding: '0 3px',
      borderRadius: 7,
      fontSize: 8,
    },
  },

  conversationInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginLeft: theme.spacing(1),
  },

  conversationTime: {
    fontSize: 11,
    color: '#888',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  chatHeaderContent: {
    display: 'flex',
    alignItems: 'center',
  },

  chatHeaderName: {
    fontWeight: 500,
  },

  chatHeaderPhone: {
    fontSize: 13,
    color: '#777',
    marginLeft: theme.spacing(1),
  },

  messageStatus: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 1,
  },

  messageStatusLida: {
    color: '#34b7f1',
  },

  messageStatusErro: {
    color: '#d32f2f',
  },

  messageStatusLista: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 4,
    fontSize: 12,
    lineHeight: 1,
  },

  imagemContainer: {
    position: 'relative',
    width: '250px',
    maxWidth: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    borderRadius: 6,
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    boxSizing: 'border-box',
  },

  imagemContainerHover: {
    '&:hover $imagemMenuArea': {
      opacity: 1,
    },
  },

  imagemMenuArea: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 130,
    height: 40,

    background:
      'linear-gradient(195deg, ' +
      'rgba(0,0,0,0.30) 0%, ' +
      'rgba(0,0,0,0.15) 10%, ' +
      'rgba(0,0,0,0) 50%, ' +
      'rgba(0,0,0,0) 100%)',

    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    padding: 4,
    boxSizing: 'border-box',
    pointerEvents: 'auto',
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },

  imagemMenuBotao: {
    color: '#fff',
    width: 36,
    height: 36,
    padding: 0,
    pointerEvents: 'auto',
  },

  botaoConversas: {
    display: 'none',
    padding: 4,
    marginRight: -4,

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },

  botaoConversasRecolhido: {
    display: 'none',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: 40,
      padding: 0,
      margin: 0,
      borderRadius: 0,
    },
  },

  iniciaisContato: {
    display: 'none',

    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      borderRadius: '50%',
      fontSize: 13,
      fontWeight: 'bold',
    },
  },

  conversasExpandidas: {
    [theme.breakpoints.down('sm')]: {
      width: 320,
      minWidth: 320,

      '& $unreadBadge': {
        position: 'static',
        marginLeft: theme.spacing(1),
        minWidth: 20,
        height: 20,
        padding: '0 6px',
        borderRadius: 10,
        fontSize: 11,
      },

      '& $conversationTime': {
        display: 'block',
      },
    },

    // NOVO
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      zIndex: 101,
      left: 0,
      top: 0,
      bottom: 0,
      width: 320,
      minWidth: 320,
      boxShadow: '4px 0 12px rgba(0, 0, 0, 0.20)',
    },
  },

  conversationTextExpandida: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },

  conversationsDivider: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  conversationsDividerExpandido: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },

  conversationsHeaderExpandido: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },

  overlayConversas: {
    display: 'none',

    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.15)',
      zIndex: 100,
      pointerEvents: 'auto',
    },
  },

  inputJanelaFechada: {
    '&::placeholder': {
      color: '#3b3b3b',
      opacity: 1,
    },
  },

  novaMensagemIndicador: {
    position: 'absolute',
    bottom: 15,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    padding: '7px 14px',
    borderRadius: 18,
    backgroundColor: '#fff',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
    fontSize: 13,
    cursor: 'pointer'
  },
});

class WhatsAppChat extends React.Component {

  messagesAreaRef = React.createRef();
  inputImagemRef = React.createRef();
  inputMensagemRef = React.createRef();
  inputAreaRef = React.createRef();
  timerPesquisa = null;
  timerJanela24h = null;

  midiasCache = {};

  state = {
    chats: [],
    carregandoChats: false,
    carregandoMaisChats: false,
    temMaisChats: true,
    ultimoChatCarregado: null,
    chatSelecionado: null,
    mensagens: [],
    carregandoMensagens: false,
    carregandoMaisMensagens: false,
    temMaisMensagens: true,
    textoMensagem: '',
    enviandoMensagem: false,
    textoPesquisa: '',
    imagemSelecionada: null,
    imagensCarregadas: {},
    arquivoImagem: null,
    previewImagem: null,
    arquivosImagem: [],
    previewsImagem: [],
    menuImagemAnchor: null,
    menuImagem: null,
    menuImagemAbrirDireita: true,
    conversasExpandidas: false,
    rascunhosChats: {},
    novaMensagemPendente: false,
    mostrarSetaFinal: false,
    alturaInputArea: 0,
  };

  componentDidMount() {
    this.loadChats();
    this.conectarWebSocket();

    if (this.inputAreaRef.current) {

      this.inputAreaResizeObserver =
        new ResizeObserver(() => {

          const altura =
            this.inputAreaRef.current
              .getBoundingClientRect()
              .height;

          this.setState({
            alturaInputArea: altura
          });

        });

      this.inputAreaResizeObserver.observe(
        this.inputAreaRef.current
      );
    }
  }

  componentWillUnmount() {
    if (this.inputAreaResizeObserver) {
      this.inputAreaResizeObserver.disconnect();
    }

    if (this.timerJanela24h) {
      clearTimeout(this.timerJanela24h);
      this.timerJanela24h = null;
    }

    if (this.websocket) {
      this.websocket.close();
      this.websocket = null;
    }
  }

  loadChats = async () => {
    try {

      this.setState({
        carregandoChats: true,
        temMaisChats: true
      });

      let phoneNumberId = '';

      const especificaEnvioPorPDV =
        getConfigField(
          'especificaenvioporpdv',
          'cfg_crm'
        );

      if (especificaEnvioPorPDV === ASIM) {

        const codPDV =
          sessionStorage.getItem('codPDV');

        const configsPDV =
          getConfigField(
            'configpdvwhatsappcloudapi',
            'cfg_crm'
          );

        const configPDV =
          configsPDV?.find(
            item =>
              String(item.codpdv) ===
              String(codPDV)
          );

        if (configPDV) {
          phoneNumberId =
            configPDV.phonenumberid;
        }

      } else {

        phoneNumberId =
          getConfigField(
            'phonenumberidwhatsappcloudapi',
            'cfg_crm'
          );

      }

      if (!phoneNumberId) {

        console.warn(
          'Phone Number ID do WhatsApp não configurado.'
        );

        return;
      }

      // console.log(
      //   'Texto pesquisa:',
      //   this.state.textoPesquisa
      // );

      const response = await api.get(
        `/whatsapp/meta/chat/${phoneNumberId}`,
        {
          params: {
            pesquisa: this.state.textoPesquisa.trim() || undefined
          }
        }
      );

      if (response.data.success) {

        const chats =
          response.data.chats;

        const ultimoChat =
          chats[chats.length - 1];

        this.setState({

          chats: chats,

          temMaisChats:
            chats.length === 50,

          ultimoChatCarregado:
            ultimoChat
              ? {
                data: ultimoChat.datahoraultimamsg,
                id: ultimoChat.id
              }
              : null

        });

      }

    } catch (error) {

      console.error(
        'Erro ao carregar conversas WhatsApp:',
        error
      );

    } finally {

      this.setState({
        carregandoChats: false
      });

    }
  };

  selecionarChat = async (chat) => {

    const chatAtual =
      this.state.chatSelecionado;

    const rascunhosAtualizados = {
      ...this.state.rascunhosChats
    };

    /*
     * Salva o rascunho da conversa atual
     */
    if (chatAtual) {

      rascunhosAtualizados[chatAtual.id] = {

        textoMensagem:
          this.state.textoMensagem,

        arquivosImagem:
          this.state.arquivosImagem,

        previewsImagem:
          this.state.previewsImagem

      };

    }

    /*
     * Recupera o rascunho da conversa selecionada
     */
    const rascunho =
      rascunhosAtualizados[chat.id];

    this.setState({

      chatSelecionado: {
        ...chat,
        qtdemsgnaolidas: 0
      },

      mensagens: [],
      carregandoMensagens: true,
      temMaisMensagens: true,

      textoMensagem:
        rascunho?.textoMensagem || '',

      arquivosImagem:
        rascunho?.arquivosImagem || [],

      previewsImagem:
        rascunho?.previewsImagem || [],

      rascunhosChats:
        rascunhosAtualizados

    });

    try {

      const response = await api.get(
        `/whatsapp/meta/chat/mensagens/${chat.id}`
      );

      if (response.data.success) {

        const mensagens =
          response.data.mensagens.reverse();

        if (chat.qtdemsgnaolidas > 0) {

          await api.put(
            `/whatsapp/meta/chat/lido/${chat.id}`
          );
        }

        this.setState(
          prevState => ({
            mensagens: mensagens,
            carregandoMensagens: false,

            chats: prevState.chats.map(item => {

              if (item.id !== chat.id) {
                return item;
              }

              return {
                ...item,
                qtdemsgnaolidas: 0
              };
            }),

            chatSelecionado: {
              ...chat,
              qtdemsgnaolidas: 0
            }
          }),
          () => {
            this.scrollToBottom();

            // Carrega as imagens em segundo plano            
            this.carregarMidiasMensagens();

            this.configurarTimerJanela24h();
          }
        );

      } else {

        this.setState({
          carregandoMensagens: false
        });

      }

    } catch (error) {

      console.error(
        'Erro ao carregar mensagens do chat:',
        error
      );

      this.setState({
        carregandoMensagens: false
      });
    }
  };

  enviarMensagem = async () => {

    const {
      chatSelecionado,
      textoMensagem,
      arquivosImagem,
      previewsImagem,
      enviandoMensagem
    } = this.state;

    const textoParaEnviar =
      textoMensagem;

    // if (!chatSelecionado || enviandoMensagem) {
    //   return;
    // }
    if (!chatSelecionado) {
      return;
    }

    /*
     * ============================================================
     * VALIDAÇÃO
     * ============================================================
     *
     * Pode enviar:
     *
     * - somente texto
     * - imagem
     * - imagem + texto
     * - várias imagens
     *
     */

    if (
      !arquivosImagem.length &&
      (!textoMensagem || !textoMensagem.trim())
    ) {
      return;
    }

    try {

      // this.setState({
      //   enviandoMensagem: true
      // });
      // this.setState({
      //   textoMensagem: '',
      //   enviandoMensagem: false
      // });
      this.setState({
        textoMensagem: '',
        arquivosImagem: [],
        previewsImagem: [],
        arquivoImagem: null,
        previewImagem: null,
        enviandoMensagem: false
      });

      const codempresa =
        sessionStorage.getItem('codEmpresa');

      const codpdv =
        sessionStorage.getItem('codPDV');

      let response;

      /*
       * ============================================================
       * ENVIO DE IMAGENS
       * ============================================================
       */

      if (arquivosImagem.length) {

        const respostasImagens = [];

        for (
          let i = 0;
          i < arquivosImagem.length;
          i++
        ) {

          const arquivo =
            arquivosImagem[i];

          const formData =
            new FormData();

          formData.append(
            'codempresa',
            codempresa || ''
          );

          formData.append(
            'codpdv',
            codpdv || ''
          );

          formData.append(
            'idchat',
            chatSelecionado.id
          );

          /*
           * O texto vai somente na primeira imagem.
           */
          formData.append(
            'texto',
            i === 0
              ? textoParaEnviar || ''
              : ''
          );

          formData.append(
            'arquivoImagem',
            arquivo
          );

          const resposta =
            await api.post(
              '/whatsapp/meta/enviaimagem',
              formData
            );

          if (resposta.data.success) {

            respostasImagens.push({

              response:
                resposta.data,

              arquivo,

              preview:
                previewsImagem[i]

            });

          } else {

            throw new Error(
              resposta.data.message ||
              'Erro ao enviar imagem.'
            );

          }

        }

        response = {

          data: {

            success: true,

            imagens:
              respostasImagens

          }

        };

      } else {

        /*
         * ============================================================
         * ENVIO DE TEXTO
         * ============================================================
         */

        response =
          await api.post(
            '/whatsapp/meta/enviamensagem',
            {

              codempresa:
                codempresa || '',

              codpdv:
                codpdv || '',

              idchat:
                chatSelecionado.id,

              // texto:
              //   textoMensagem
              texto:
                textoParaEnviar

            }
          );

      }

      /*
       * ============================================================
       * SUCESSO
       * ============================================================
       */

      if (response.data.success) {

        // let novasMensagens = [];

        // /*
        //  * ==========================================================
        //  * MENSAGENS DE IMAGEM
        //  * ==========================================================
        //  */

        // if (arquivosImagem.length) {

        //   novasMensagens =
        //     response.data.imagens.map(
        //       (item) => {

        //         const dados =
        //           item.response;

        //         return {

        //           id:
        //             dados.idMensagem,

        //           idmsgmeta:
        //             dados.idMsgMeta,

        //           direcao:
        //             DIRECAO_MSG_CHAT_ENVIADA,

        //           tipo:
        //             dados.tipo,

        //           texto:
        //             dados.texto || '',

        //           datahoramsg:
        //             dados.dataHoraMsg,

        //           status:
        //             dados.status,

        //           urlmidia:
        //             item.preview,

        //           mimeType:
        //             dados.mimeType ||
        //             item.arquivo.type,

        //           nomearquivo:
        //             dados.nomeArquivo ||
        //             item.arquivo.name

        //         };

        //       }
        //     );

        // } else {

        //   /*
        //    * ==========================================================
        //    * MENSAGEM DE TEXTO
        //    * ==========================================================
        //    */

        //   novasMensagens = [

        //     {

        //       id:
        //         response.data.idMensagem,

        //       idmsgmeta:
        //         response.data.idMsgMeta,

        //       direcao:
        //         DIRECAO_MSG_CHAT_ENVIADA,

        //       tipo:
        //         response.data.tipo,

        //       texto:
        //         response.data.texto || '',

        //       datahoramsg:
        //         response.data.dataHoraMsg,

        //       status:
        //         response.data.status,

        //       urlmidia:
        //         null,

        //       mimeType:
        //         null,

        //       nomearquivo:
        //         null

        //     }

        //   ];

        // }

        // /*
        //  * ============================================================
        //  * ÚLTIMA MENSAGEM ENVIADA
        //  * ============================================================
        //  */

        // const ultimaMensagem =
        //   novasMensagens[
        //   novasMensagens.length - 1
        //   ];

        // /*
        //  * ============================================================
        //  * ADICIONA MENSAGENS AO CHAT
        //  * ============================================================
        //  */

        // this.setState(
        //   (prevState) => ({

        //     mensagens: [
        //       ...prevState.mensagens,
        //       ...novasMensagens.filter(
        //         novaMensagem =>
        //           !prevState.mensagens.some(
        //             mensagemExistente =>
        //               Number(mensagemExistente.id) ===
        //               Number(novaMensagem.id)
        //           )
        //       )
        //     ],

        //     textoMensagem: '',

        //     /*
        //      * Limpa as imagens selecionadas.
        //      *
        //      * Não usamos cancelarImagem(),
        //      * pois ela faria revokeObjectURL().
        //      */

        //     arquivosImagem: [],
        //     previewsImagem: [],

        //     arquivoImagem: null,
        //     previewImagem: null,

        //     chats: (() => {

        //       let chatAtualizado = null;

        //       const outrosChats =
        //         prevState.chats.filter(
        //           (chat) => {

        //             if (
        //               Number(chat.id) ===
        //               Number(chatSelecionado.id)
        //             ) {

        //               chatAtualizado = {

        //                 ...chat,

        //                 datahoraultimamsg:
        //                   ultimaMensagem.datahoramsg,

        //                 ultimamensagem: {

        //                   ...chat.ultimamensagem,

        //                   id:
        //                     ultimaMensagem.id,

        //                   idmsgmeta:
        //                     ultimaMensagem.idmsgmeta,

        //                   direcao:
        //                     ultimaMensagem.direcao,

        //                   tipo:
        //                     ultimaMensagem.tipo,

        //                   texto:
        //                     ultimaMensagem.texto,

        //                   datahoramsg:
        //                     ultimaMensagem.datahoramsg,

        //                   status:
        //                     ultimaMensagem.status

        //                 }

        //               };

        //               return false;
        //             }

        //             return true;

        //           }
        //         );

        //       if (!chatAtualizado) {
        //         return prevState.chats;
        //       }

        //       return [
        //         chatAtualizado,
        //         ...outrosChats
        //       ];

        //     })()

        //   }),

        //   () => {

        //     this.scrollToBottom();

        //   }

        // );

      } else {

        const idMensagem =
          response.data.idMensagem;

        this.setState(prevState => ({
          mensagens:
            prevState.mensagens.map(
              mensagem =>
                Number(mensagem.id) ===
                  Number(idMensagem)
                  ? {
                    ...mensagem,
                    status: STATUS_MSG_CHAT_ERRO,
                    coderro: null,
                    erro:
                      response.data.error
                  }
                  : mensagem
            )
        }));

      }

    } catch (error) {

      console.error(
        'Erro ao enviar mensagem WhatsApp:',
        error
      );

    } finally {

      if (this.inputMensagemRef.current) {
        this.inputMensagemRef.current.focus();
      }

    }

  };

  scrollToBottom = () => {
    if (this.messagesAreaRef.current) {
      requestAnimationFrame(() => {
        this.messagesAreaRef.current.scrollTop =
          this.messagesAreaRef.current.scrollHeight;
      });
    }
  };

  estaNoFinalMensagens = () => {

    const area = this.messagesAreaRef.current;

    if (!area) {
      return true;
    }

    const distanciaDoFinal = area.scrollHeight - area.scrollTop - area.clientHeight;

    return distanciaDoFinal <= 50;
  };

  formatarHora = (dataHora) => {

    if (!dataHora) {
      return '';
    }

    const data = new Date(dataHora);

    if (isNaN(data.getTime())) {
      return '';
    }

    return data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  formatarDataMensagem = (dataHora) => {

    if (!dataHora) {
      return '';
    }

    const data = new Date(dataHora);

    if (isNaN(data.getTime())) {
      return '';
    }

    const hoje = new Date();

    const ontem = new Date();
    ontem.setDate(hoje.getDate() - 1);

    const mesmaData = (data1, data2) => {
      return (
        data1.getFullYear() === data2.getFullYear() &&
        data1.getMonth() === data2.getMonth() &&
        data1.getDate() === data2.getDate()
      );
    };

    if (mesmaData(data, hoje)) {
      return 'Hoje';
    }

    if (mesmaData(data, ontem)) {
      return 'Ontem';
    }

    return data.toLocaleDateString('pt-BR');
  };

  deveMostrarData = (mensagem, indice) => {

    if (indice === 0) {
      return true;
    }

    const mensagemAnterior = this.state.mensagens[indice - 1];

    if (!mensagemAnterior) {
      return true;
    }

    const dataAtual = new Date(mensagem.datahoramsg);
    const dataAnterior = new Date(mensagemAnterior.datahoramsg);

    return !(
      dataAtual.getFullYear() === dataAnterior.getFullYear() &&
      dataAtual.getMonth() === dataAnterior.getMonth() &&
      dataAtual.getDate() === dataAnterior.getDate()
    );
  };

  formatarDataLista = (dataHora) => {

    if (!dataHora) {
      return '';
    }

    const data = new Date(dataHora);

    if (isNaN(data.getTime())) {
      return '';
    }

    const hoje = new Date();

    const ontem = new Date();
    ontem.setDate(hoje.getDate() - 1);

    const mesmaData = (data1, data2) => {
      return (
        data1.getFullYear() === data2.getFullYear() &&
        data1.getMonth() === data2.getMonth() &&
        data1.getDate() === data2.getDate()
      );
    };

    /*
     * Mensagem de hoje
     */
    if (mesmaData(data, hoje)) {
      return data.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    /*
     * Mensagem de ontem
     */
    if (mesmaData(data, ontem)) {
      return 'Ontem';
    }

    /*
     * Mensagem anterior
     */
    return data.toLocaleDateString('pt-BR');
  };

  renderStatusMensagem = (mensagem) => {

    if (mensagem.direcao !== DIRECAO_MSG_CHAT_ENVIADA) {
      return null;
    }

    switch (mensagem.status) {

      case STATUS_MSG_CHAT_ENVIANDO:
        return (
          <span className={this.props.classes.messageStatus}>
            <AccessTime
              style={{
                fontSize: 13,
                verticalAlign: 'middle'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_ENVIADA:
        return (
          <span className={this.props.classes.messageStatus}>
            <Check
              style={{
                fontSize: 15,
                verticalAlign: 'middle'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_RECEBIDA:
        return (
          <span className={this.props.classes.messageStatus}>
            <DoneAll
              style={{
                fontSize: 15,
                verticalAlign: 'middle'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_LIDA:
        return (
          <span
            className={`${this.props.classes.messageStatus} ${this.props.classes.messageStatusLida}`}
          >
            <DoneAll
              style={{
                fontSize: 15,
                verticalAlign: 'middle'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_ERRO:
        return (
          <span
            className={`${this.props.classes.messageStatus} ${this.props.classes.messageStatusErro}`}
          >
            <ErrorOutline
              style={{
                fontSize: 15,
                verticalAlign: 'middle'
              }}
            />
          </span>
        );

      default:
        return null;
    }
  };

  renderHorarioStatus = (mensagem) => {
    const enviada =
      mensagem.direcao === DIRECAO_MSG_CHAT_ENVIADA;

    return (
      <span className={this.props.classes.messageTime}>

        {this.formatarHora(mensagem.datahoramsg)}

        {enviada && this.renderStatusMensagem(mensagem)}

      </span>
    );
  };

  carregarMidia = async (mensagem) => {

    // Verifica se já está no cache
    if (this.midiasCache[mensagem.id]) {
      return this.midiasCache[mensagem.id];
    }

    try {

      const codempresa = getConfigField('codempresa', 'cfg_crm');

      const response = await api.get(
        `/whatsapp/meta/chat/midia/${mensagem.id}`,
        {
          params: {
            codempresa
          },
          responseType: 'blob'
        }
      );

      const url = URL.createObjectURL(response.data);

      // Guarda no cache
      this.midiasCache[mensagem.id] = url;

      return url;

    } catch (error) {

      console.error(
        'Erro ao carregar mídia da mensagem:',
        mensagem.id,
        error
      );

      return null;
    }
  };

  carregarMidiasMensagens = async () => {

    const mensagens = [...this.state.mensagens]
      .reverse()
      .filter(
        mensagem => mensagem.tipo === TIPO_MSG_CHAT_IMAGEM
      );

    await Promise.all(
      mensagens.map(async (mensagem) => {

        const url = await this.carregarMidia(mensagem);

        if (!url) {
          return;
        }

        this.setState(
          prevState => ({
            mensagens: prevState.mensagens.map(item =>
              item.id === mensagem.id
                ? {
                  ...item,
                  urlmidia: url
                }
                : item
            )
          })
        );
      })
    );
  };

  imagemCarregada = (id) => {

    this.setState(prevState => ({
      imagensCarregadas: {
        ...prevState.imagensCarregadas,
        [id]: true
      }
    }));

  };

  abrirImagem = (urlImagem) => {
    if (!urlImagem) {
      return;
    }

    this.setState({
      imagemSelecionada: urlImagem
    });
  };

  fecharImagem = () => {
    this.setState({
      imagemSelecionada: null
    });
  };

  renderUltimaMensagem = (mensagem) => {

    if (!mensagem) {
      return '';
    }

    const enviada =
      mensagem.direcao === DIRECAO_MSG_CHAT_ENVIADA;

    /*
     * IMAGEM
     */
    if (mensagem.tipo === TIPO_MSG_CHAT_IMAGEM) {

      return (
        <span>
          {enviada &&
            this.renderStatusMensagemLista(mensagem)}

          <ImageIcon
            style={{
              fontSize: 18,
              marginRight: 4,
              verticalAlign: 'middle'
            }}
          />

          {mensagem.texto
            ? this.formatarTextoWhatsAppLista(
              mensagem.texto
            )
            : 'Imagem'}
        </span>
      );
    }

    /*
     * DOCUMENTO
     */
    if (mensagem.tipo === TIPO_MSG_CHAT_DOCUMENTO) {

      return (
        <span>
          {enviada &&
            this.renderStatusMensagemLista(mensagem)}

          {mensagem.nomearquivo || 'Documento'}
        </span>
      );
    }

    /*
     * TEXTO
     */
    return (
      <span>
        {enviada &&
          this.renderStatusMensagemLista(mensagem)}

        {this.formatarTextoWhatsAppLista(
          mensagem.texto || ''
        )}
      </span>
    );
  };

  renderStatusMensagemLista = (mensagem) => {

    if (mensagem.direcao !== DIRECAO_MSG_CHAT_ENVIADA) {
      return null;
    }

    const classes = this.props.classes;

    switch (mensagem.status) {

      case STATUS_MSG_CHAT_ENVIANDO:
        return (
          <span className={classes.messageStatusLista}>
            <AccessTime
              style={{
                fontSize: 12,
                verticalAlign: 'middle',
                position: 'relative',
                top: '3px'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_ENVIADA:
        return (
          <span className={classes.messageStatusLista}>
            <Check
              style={{
                fontSize: 14,
                verticalAlign: 'middle',
                position: 'relative',
                top: '3px'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_RECEBIDA:
        return (
          <span className={classes.messageStatusLista}>
            <DoneAll
              style={{
                fontSize: 14,
                verticalAlign: 'middle',
                position: 'relative',
                top: '3px'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_LIDA:
        return (
          <span
            className={`${classes.messageStatusLista} ${classes.messageStatusLida}`}
          >
            <DoneAll
              style={{
                fontSize: 14,
                verticalAlign: 'middle',
                position: 'relative',
                top: '3px'
              }}
            />
          </span>
        );

      case STATUS_MSG_CHAT_ERRO:
        return (
          <span
            className={`${classes.messageStatusLista} ${classes.messageStatusErro}`}
          >
            <ErrorOutline
              style={{
                fontSize: 14,
                verticalAlign: 'middle',
                position: 'relative',
                top: '3px'
              }}
            />
          </span>
        );

      default:
        return null;
    }
  };

  formatarTextoWhatsApp = (texto) => {

    if (!texto) {
      return '';
    }

    const formatar = (texto, nivel = 0) => {

      if (!texto || nivel > 10) {
        return texto;
      }

      const partes = [];
      let restante = texto;
      let chave = 0;

      while (restante.length > 0) {

        /*
         * Monoespaçado
         * `texto`
         */
        const matchMonoespaco = restante.match(/`([^`]+)`/);

        /*
         * Negrito
         * *texto*
         */
        const matchNegrito = restante.match(/\*([^*\n]+)\*/);

        /*
         * Itálico
         * _texto_
         */
        const matchItalico = restante.match(/_([^_\n]+)_/);

        /*
         * Tachado
         * ~texto~
         */
        const matchTachado = restante.match(/~([^~\n]+)~/);

        const matches = [
          {
            tipo: 'monoespaco',
            match: matchMonoespaco
          },
          {
            tipo: 'negrito',
            match: matchNegrito
          },
          {
            tipo: 'italico',
            match: matchItalico
          },
          {
            tipo: 'tachado',
            match: matchTachado
          }
        ].filter(item => item.match);

        /*
         * Não encontrou nenhum marcador.
         * Adiciona o restante como texto normal.
         */
        if (matches.length === 0) {
          partes.push(restante);
          break;
        }

        /*
         * Pega o marcador que aparece primeiro no texto.
         */
        matches.sort(
          (a, b) => a.match.index - b.match.index
        );

        const primeiro = matches[0];

        /*
         * Texto antes do marcador.
         */
        if (primeiro.match.index > 0) {
          partes.push(
            restante.substring(0, primeiro.match.index)
          );
        }

        const conteudo = primeiro.match[1];

        /*
         * Aplica o estilo correspondente.
         */
        switch (primeiro.tipo) {

          case 'negrito':
            partes.push(
              <strong key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </strong>
            );
            break;

          case 'italico':
            partes.push(
              <em key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </em>
            );
            break;

          case 'tachado':
            partes.push(
              <del key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </del>
            );
            break;

          case 'monoespaco':
            partes.push(
              <code
                key={chave++}
                style={{
                  fontFamily: 'monospace',
                  backgroundColor: '#f0f0f0',
                  padding: '1px 4px',
                  borderRadius: 3
                }}
              >
                {conteudo}
              </code>
            );
            break;
        }

        /*
         * Continua processando o que vem depois.
         */
        restante = restante.substring(
          primeiro.match.index + primeiro.match[0].length
        );
      }

      return partes;
    };

    /*
     * Preserva as quebras de linha.
     */
    const linhas = texto.split('\n');

    return linhas.map((linha, index) => (
      <React.Fragment key={index}>

        {formatar(linha)}

        {index < linhas.length - 1 && <br />}

      </React.Fragment>
    ));
  };

  formatarTextoWhatsAppLista = (texto) => {

    if (!texto) {
      return '';
    }

    const formatar = (texto, nivel = 0) => {

      if (!texto || nivel > 10) {
        return texto;
      }

      const partes = [];
      let restante = texto;
      let chave = 0;

      while (restante.length > 0) {

        const matchMonoespaco =
          restante.match(/`([^`]+)`/);

        const matchNegrito =
          restante.match(/\*([^*\n]+)\*/);

        const matchItalico =
          restante.match(/_([^_\n]+)_/);

        const matchTachado =
          restante.match(/~([^~\n]+)~/);

        const matches = [
          {
            tipo: 'monoespaco',
            match: matchMonoespaco
          },
          {
            tipo: 'negrito',
            match: matchNegrito
          },
          {
            tipo: 'italico',
            match: matchItalico
          },
          {
            tipo: 'tachado',
            match: matchTachado
          }
        ].filter(item => item.match);

        if (matches.length === 0) {
          partes.push(restante);
          break;
        }

        matches.sort(
          (a, b) => a.match.index - b.match.index
        );

        const primeiro = matches[0];

        if (primeiro.match.index > 0) {
          partes.push(
            restante.substring(
              0,
              primeiro.match.index
            )
          );
        }

        const conteudo = primeiro.match[1];

        switch (primeiro.tipo) {

          case 'negrito':
            partes.push(
              <strong key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </strong>
            );
            break;

          case 'italico':
            partes.push(
              <em key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </em>
            );
            break;

          case 'tachado':
            partes.push(
              <del key={chave++}>
                {formatar(conteudo, nivel + 1)}
              </del>
            );
            break;

          case 'monoespaco':
            partes.push(
              <code
                key={chave++}
                style={{
                  fontFamily: 'monospace',
                  backgroundColor: '#f0f0f0',
                  padding: '1px 4px',
                  borderRadius: 3
                }}
              >
                {conteudo}
              </code>
            );
            break;
        }

        restante = restante.substring(
          primeiro.match.index +
          primeiro.match[0].length
        );
      }

      return partes;
    };

    /*
     * Na lista, remove as quebras de linha.
     * Isso permite que o noWrap do ListItemText
     * funcione corretamente.
     */
    return formatar(
      texto.replace(/\r?\n/g, ' ')
    );
  };

  selecionarImagem = (event) => {

    const arquivos = Array.from(
      event.target.files || []
    );

    if (!arquivos.length) {
      return;
    }

    const imagensValidas = arquivos.filter(
      (arquivo) =>
        arquivo.type.startsWith('image/')
    );

    if (imagensValidas.length !== arquivos.length) {
      alert('Selecione somente arquivos de imagem.');
    }

    if (!imagensValidas.length) {
      event.target.value = '';
      return;
    }

    const previews = imagensValidas.map(
      (arquivo) =>
        URL.createObjectURL(arquivo)
    );

    const estavaNoFinal =
      this.estaNoFinalMensagens();

    this.setState({
      arquivosImagem: imagensValidas,
      previewsImagem: previews
    }, () => {

      if (estavaNoFinal) {
        this.scrollToBottom();
      }

    });

    event.target.value = '';
  };

  cancelarImagem = () => {

    if (this.state.previewImagem) {
      URL.revokeObjectURL(this.state.previewImagem);
    }

    this.setState({
      arquivoImagem: null,
      previewImagem: null
    });
  };

  removerImagem = (index) => {

    const preview =
      this.state.previewsImagem[index];

    if (preview) {
      URL.revokeObjectURL(preview);
    }

    this.setState((prevState) => ({

      arquivosImagem:
        prevState.arquivosImagem.filter(
          (_, i) => i !== index
        ),

      previewsImagem:
        prevState.previewsImagem.filter(
          (_, i) => i !== index
        )

    }));

  };

  abrirMenuImagem = (event, mensagem) => {

    const rect = event.currentTarget.getBoundingClientRect();

    const larguraMenu = 100;

    const espacoDireita =
      window.innerWidth - rect.left;

    const abrirDireita =
      espacoDireita >= larguraMenu;

    this.setState({
      menuImagemAnchor: event.currentTarget,
      menuImagem: mensagem,
      menuImagemAbrirDireita: abrirDireita
    });

  };

  fecharMenuImagem = () => {

    this.setState({
      menuImagemAnchor: null,
      menuImagem: null
    });

  };

  baixarImagem = async (mensagem) => {

    if (!mensagem || !mensagem.urlmidia) {
      return;
    }

    try {

      /*
       * ============================================================
       * MIME TYPE DA IMAGEM
       * ============================================================
       */

      const mimeType =
        mensagem.mimeType ||
        'image/jpeg';

      /*
       * ============================================================
       * EXTENSÃO DO ARQUIVO
       * ============================================================
       */

      const extensoes = {
        'image/jpeg': '.jpg',
        'image/jpg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/webp': '.webp',
        'image/bmp': '.bmp',
        'image/tiff': '.tif'
      };

      const extensao =
        extensoes[mimeType] || '.jpg';

      /*
       * ============================================================
       * NOME DO ARQUIVO
       * ============================================================
       */

      let nomeArquivo =
        mensagem.nomearquivo ||
        `imagem_${mensagem.id}${extensao}`;

      /*
       * Se o nome existente não possuir extensão,
       * adiciona a extensão correspondente ao MIME.
       */
      if (
        mensagem.nomearquivo &&
        !/\.[^/.]+$/.test(mensagem.nomearquivo)
      ) {
        nomeArquivo += extensao;
      }

      /*
       * ============================================================
       * ABRE A JANELA "SALVAR COMO"
       * ============================================================
       */

      const handle = await window.showSaveFilePicker({

        suggestedName: nomeArquivo,

        types: [
          {
            description: 'Imagem',
            accept: {
              [mimeType]: [extensao]
            }
          }
        ]
      });

      /*
       * ============================================================
       * BAIXA A IMAGEM
       * ============================================================
       */

      const response = await fetch(
        mensagem.urlmidia
      );

      if (!response.ok) {
        throw new Error(
          `Erro ao baixar imagem: ${response.status}`
        );
      }

      const blob = await response.blob();

      /*
       * ============================================================
       * GRAVA O ARQUIVO
       * ============================================================
       */

      const writable =
        await handle.createWritable();

      await writable.write(blob);

      await writable.close();

    } catch (error) {

      /*
       * Usuário cancelou a janela de salvar.
       */
      if (error.name === 'AbortError') {
        return;
      }

      console.error(
        'Erro ao baixar imagem:',
        error
      );
    }
  };

  alternarConversas = () => {
    this.setState((prevState) => ({
      conversasExpandidas: !prevState.conversasExpandidas,
    }));
  };

  obterIniciaisContato = (nome) => {
    if (!nome) return '?';

    const partes = nome.trim().split(/\s+/);

    if (partes.length === 1) {
      return partes[0].charAt(0).toUpperCase();
    }

    return (
      partes[0].charAt(0) +
      partes[partes.length - 1].charAt(0)
    ).toUpperCase();
  };

  handleScrollMensagens = (event) => {

    const elemento = event.target;

    if (elemento.scrollTop === 0) {

      this.carregarMensagensAnteriores();

    }

    const estaNoFinal =
      this.estaNoFinalMensagens();

    // console.log(
    //   'Scroll - estaNoFinal:',
    //   estaNoFinal
    // );

    const estavaLongeDoFinal =
      this.state.mostrarSetaFinal;

    this.setState({
      mostrarSetaFinal: !estaNoFinal
    });

    if (
      estaNoFinal &&
      estavaLongeDoFinal &&
      this.state.chatSelecionado
    ) {

      const idChat =
        this.state.chatSelecionado.id;

      api.put(
        `/whatsapp/meta/chat/lido/${idChat}`
      )
        .then(() => {

          this.setState(
            prevState => ({
              chats:
                prevState.chats.map(chat =>
                  Number(chat.id) ===
                    Number(idChat)
                    ? {
                      ...chat,
                      qtdemsgnaolidas: 0
                    }
                    : chat
                ),

              chatSelecionado: {
                ...prevState.chatSelecionado,
                qtdemsgnaolidas: 0
              }
            })
          );

        })
        .catch(error => {

          console.error(
            'Erro ao marcar conversa como lida:',
            error
          );

        });

    }

  };

  carregarMensagensAnteriores = async () => {

    const {
      chatSelecionado,
      mensagens,
      carregandoMaisMensagens,
      temMaisMensagens
    } = this.state;

    if (
      !chatSelecionado ||
      carregandoMaisMensagens ||
      !temMaisMensagens ||
      !mensagens.length
    ) {
      return false;
    }

    const idMensagemMaisAntiga =
      mensagens[0].id;

    try {

      this.setState({
        carregandoMaisMensagens: true
      });

      const response = await api.get(
        `/whatsapp/meta/chat/mensagens/${chatSelecionado.id}?antesDe=${idMensagemMaisAntiga}`
      );

      if (response.data.success) {

        const mensagensAnteriores =
          response.data.mensagens.reverse();

        if (mensagensAnteriores.length < 50) {

          this.setState({
            temMaisMensagens: false
          });

        }

        if (!mensagensAnteriores.length) {
          return false;
        }

        const elemento =
          this.messagesAreaRef.current;

        const alturaAnterior =
          elemento.scrollHeight;

        await new Promise(resolve => {

          this.setState(
            prevState => ({
              mensagens: [
                ...mensagensAnteriores,
                ...prevState.mensagens
              ]
            }),
            resolve
          );

        });

        const alturaNova =
          elemento.scrollHeight;

        elemento.scrollTop =
          alturaNova - alturaAnterior;

        this.carregarMidiasMensagens();

        return true;
      }

      return false;

    } catch (error) {

      console.error(
        'Erro ao carregar mensagens anteriores:',
        error
      );

      return false;

    } finally {

      this.setState({
        carregandoMaisMensagens: false
      });

    }

  };

  carregarChatsAnteriores = async () => {

    const {
      carregandoMaisChats,
      temMaisChats,
      ultimoChatCarregado
    } = this.state;

    if (
      carregandoMaisChats ||
      !temMaisChats ||
      !ultimoChatCarregado
    ) {
      return;
    }

    try {

      this.setState({
        carregandoMaisChats: true
      });

      let phoneNumberId = '';

      const especificaEnvioPorPDV =
        getConfigField(
          'especificaenvioporpdv',
          'cfg_crm'
        );

      if (especificaEnvioPorPDV === ASIM) {

        const codPDV =
          sessionStorage.getItem('codPDV');

        const configsPDV =
          getConfigField(
            'configpdvwhatsappcloudapi',
            'cfg_crm'
          );

        const configPDV =
          configsPDV?.find(
            item =>
              String(item.codpdv) ===
              String(codPDV)
          );

        if (configPDV) {
          phoneNumberId =
            configPDV.phonenumberid;
        }

      } else {

        phoneNumberId =
          getConfigField(
            'phonenumberidwhatsappcloudapi',
            'cfg_crm'
          );

      }

      if (!phoneNumberId) {

        console.warn(
          'Phone Number ID do WhatsApp não configurado.'
        );

        return;
      }

      const dataCursor =
        this.formatarDataParaAPI(
          ultimoChatCarregado.data
        );

      const response = await api.get(
        `/whatsapp/meta/chat/${phoneNumberId}`,
        {
          params: {
            antesDeData:
              dataCursor,

            antesDeId:
              ultimoChatCarregado.id
          }
        }
      );

      if (response.data.success) {

        const chatsAnteriores =
          response.data.chats;

        if (chatsAnteriores.length < 50) {

          this.setState({
            temMaisChats: false
          });

        }

        if (!chatsAnteriores.length) {
          return;
        }

        const ultimoChat =
          chatsAnteriores[
          chatsAnteriores.length - 1
          ];

        this.setState(
          prevState => ({
            chats: [
              ...prevState.chats,
              ...chatsAnteriores
            ],

            ultimoChatCarregado: {
              data:
                ultimoChat.datahoraultimamsg,

              id:
                ultimoChat.id
            }
          })
        );

      }

    } catch (error) {

      console.error(
        'Erro ao carregar conversas anteriores:',
        error
      );

    } finally {

      this.setState({
        carregandoMaisChats: false
      });

    }

  };

  formatarDataParaAPI = (data) => {

    const d = new Date(data);

    const ano =
      d.getFullYear();

    const mes =
      String(d.getMonth() + 1)
        .padStart(2, '0');

    const dia =
      String(d.getDate())
        .padStart(2, '0');

    const hora =
      String(d.getHours())
        .padStart(2, '0');

    const minuto =
      String(d.getMinutes())
        .padStart(2, '0');

    const segundo =
      String(d.getSeconds())
        .padStart(2, '0');

    const milissegundo =
      String(d.getMilliseconds())
        .padStart(3, '0');

    return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}.${milissegundo}`;
  };

  conectarWebSocket = () => {

    let phoneNumberId = '';

    const especificaEnvioPorPDV = getConfigField('especificaenvioporpdv', 'cfg_crm');

    if (especificaEnvioPorPDV === ASIM) {

      const codPDV = sessionStorage.getItem('codPDV');
      const configsPDV = getConfigField('configpdvwhatsappcloudapi', 'cfg_crm');

      const configPDV = configsPDV?.find(item => String(item.codpdv) === String(codPDV));

      if (configPDV) {
        phoneNumberId = configPDV.phonenumberid;
      }

    } else {

      phoneNumberId = getConfigField('phonenumberidwhatsappcloudapi', 'cfg_crm');

    }

    if (!phoneNumberId) {
      console.warn('Phone Number ID não configurado para o WebSocket.');
      return;
    }

    const ws = new WebSocket(WEBSOCKETURL);

    ws.onopen = () => {

      console.log('WebSocket conectado');

      ws.send(JSON.stringify({
        evento: 'identificacao',
        phone_number_id: phoneNumberId
      }));

    };

    ws.onmessage = (event) => {

      // console.log(
      //   '>>> WEBSOCKET RECEBIDO NO REACT:',
      //   event.data
      // );

      const mensagem = JSON.parse(event.data);

      // console.log(
      //   'Evento WebSocket recebido:',
      //   mensagem
      // );

      if (
        mensagem.evento !== 'whatsapp.nova_mensagem' &&
        mensagem.evento !== 'whatsapp.mensagem_atualizada'
      ) {
        return;
      }

      const novaMensagem = mensagem.dados?.mensagem;

      if (!novaMensagem) {
        return;
      }

      if (mensagem.evento === 'whatsapp.mensagem_atualizada') {

        this.setState(
          prevState => ({
            mensagens:
              prevState.mensagens.map(
                mensagemExistente =>
                  Number(mensagemExistente.id) ===
                    Number(novaMensagem.id)
                    ? {
                      ...mensagemExistente,
                      ...novaMensagem
                    }
                    : mensagemExistente
              ),

            chats:
              prevState.chats.map(
                chat => {

                  if (
                    Number(chat.id) !==
                    Number(novaMensagem.idchat)
                  ) {
                    return chat;
                  }

                  if (
                    !chat.ultimamensagem ||
                    Number(chat.ultimamensagem.id) !==
                    Number(novaMensagem.id)
                  ) {
                    return chat;
                  }

                  return {
                    ...chat,

                    ultimamensagem: {
                      ...chat.ultimamensagem,
                      status: novaMensagem.status
                    }

                  };

                }
              )
          }),
          async () => {

            if (
              novaMensagem.tipo ===
              TIPO_MSG_CHAT_IMAGEM &&
              novaMensagem.midiaid
            ) {

              const url =
                await this.carregarMidia(
                  novaMensagem
                );

              if (url) {

                this.setState(
                  prevState => ({
                    mensagens:
                      prevState.mensagens.map(
                        mensagemExistente =>
                          Number(mensagemExistente.id) ===
                            Number(novaMensagem.id)
                            ? {
                              ...mensagemExistente,
                              urlmidia: url
                            }
                            : mensagemExistente
                      )
                  })
                );

              }

            }

          }
        );

        return;
      }

      const mensagemJaExiste =
        this.state.mensagens.some(
          mensagemExistente =>
            Number(mensagemExistente.id) ===
            Number(novaMensagem.id)
        );

      if (mensagemJaExiste) {
        return;
      }

      const idChatSelecionado = this.state.chatSelecionado?.id;

      // Mensagem pertence ao chat que está aberto
      if (
        idChatSelecionado &&
        Number(novaMensagem.idchat) === Number(idChatSelecionado)
      ) {

        const estavaNoFinal =
          this.estaNoFinalMensagens();

        this.setState(
          prevState => {

            let chatAtualizado = null;

            const outrosChats =
              prevState.chats.filter(chat => {

                if (
                  Number(chat.id) ===
                  Number(novaMensagem.idchat)
                ) {

                  const qtdemsgnaolidas =
                    novaMensagem.direcao ===
                      DIRECAO_MSG_CHAT_RECEBIDA
                      ? (
                        estavaNoFinal
                          ? 0
                          : (Number(chat.qtdemsgnaolidas) || 0) + 1
                      )
                      : Number(chat.qtdemsgnaolidas) || 0;

                  chatAtualizado = {
                    ...chat,
                    ultimamensagem: novaMensagem,
                    datahoraultimamsg: novaMensagem.datahoramsg,
                    qtdemsgnaolidas,

                    ...(novaMensagem.direcao === DIRECAO_MSG_CHAT_RECEBIDA
                      ? {
                        datahorafimjanela:
                          novaMensagem.datahorafimjanela
                      }
                      : {})
                  };

                  return false;
                }

                return true;

              });

            if (!chatAtualizado) {
              return {
                mensagens: [
                  ...prevState.mensagens,
                  novaMensagem
                ]
              };
            }

            return {
              mensagens: [
                ...prevState.mensagens,
                novaMensagem
              ],

              chats: [
                chatAtualizado,
                ...outrosChats
              ],

              chatSelecionado:
                prevState.chatSelecionado &&
                  Number(prevState.chatSelecionado.id) === Number(novaMensagem.idchat)
                  ? {
                    ...prevState.chatSelecionado,

                    qtdemsgnaolidas:
                      chatAtualizado.qtdemsgnaolidas,

                    ...(novaMensagem.direcao === DIRECAO_MSG_CHAT_RECEBIDA
                      ? {
                        datahorafimjanela:
                          novaMensagem.datahorafimjanela
                      }
                      : {})
                  }
                  : prevState.chatSelecionado,

              novaMensagemPendente:
                !estavaNoFinal
            };

          },
          async () => {

            this.configurarTimerJanela24h();

            if (estavaNoFinal) {

              this.scrollToBottom();

              try {

                await api.put(
                  `/whatsapp/meta/chat/lido/${novaMensagem.idchat}`
                );

              } catch (error) {

                console.error(
                  'Erro ao marcar conversa como lida:',
                  error
                );

              }

            }

            /*
             * Se for imagem, carrega a mídia da Meta.
             */
            if (
              novaMensagem.tipo ===
              TIPO_MSG_CHAT_IMAGEM
            ) {

              const url =
                await this.carregarMidia(
                  novaMensagem
                );

              if (url) {

                this.setState(
                  prevState => ({
                    mensagens:
                      prevState.mensagens.map(
                        item =>
                          item.id ===
                            novaMensagem.id
                            ? {
                              ...item,
                              urlmidia: url
                            }
                            : item
                      )
                  })
                );

              }

            }

          }
        );

        return;
      }

      // Mensagem pertence a outro chat
      this.setState(
        prevState => {

          let chatAtualizado = null;

          const outrosChats =
            prevState.chats.filter(chat => {

              if (
                Number(chat.id) ===
                Number(novaMensagem.idchat)
              ) {
                chatAtualizado = {
                  ...chat,

                  ultimamensagem:
                    novaMensagem,

                  datahoraultimamsg:
                    novaMensagem.datahoramsg,

                  datahorafimjanela:
                    novaMensagem.datahorafimjanela,

                  qtdemsgnaolidas:
                    novaMensagem.direcao ===
                      DIRECAO_MSG_CHAT_RECEBIDA
                      ? (Number(chat.qtdemsgnaolidas) || 0) + 1
                      : Number(chat.qtdemsgnaolidas) || 0
                };

                return false;
              }

              return true;

            });

          if (!chatAtualizado) {

            const novoChat = {
              id: novaMensagem.idchat,
              phone_number_id: novaMensagem.phone_number_id,
              wa_id: novaMensagem.wa_id,
              fone: novaMensagem.fone,
              nomecontato: novaMensagem.nomecontato,

              datahorainicio:
                novaMensagem.datahorainicio,

              datahoraultimamsg:
                novaMensagem.datahoramsg,

              datahoraultimamsgrecebida:
                novaMensagem.datahoramsg,

              datahorafimjanela:
                novaMensagem.datahorafimjanela,

              qtdemsgnaolidas:
                novaMensagem.qtdemsgnaolidas,

              ultimamensagem:
                novaMensagem
            };

            return {
              chats: [
                novoChat,
                ...prevState.chats
              ]
            };
          }

          return {
            chats: [
              chatAtualizado,
              ...outrosChats
            ]
          };

        }
      );

    };

    ws.onclose = () => {

      console.log('WebSocket desconectado');

    };

    ws.onerror = (error) => {

      console.error('Erro no WebSocket:', error);

    };

    this.websocket = ws;

  };

  configurarTimerJanela24h = () => {

    // Cancela o timer anterior
    if (this.timerJanela24h) {

      clearTimeout(this.timerJanela24h);

      this.timerJanela24h = null;
    }

    const chatSelecionado =
      this.state.chatSelecionado;

    if (
      !chatSelecionado ||
      !chatSelecionado.datahorafimjanela
    ) {
      return;
    }

    const dataFim =
      new Date(
        chatSelecionado.datahorafimjanela
      );

    const agora =
      new Date();

    const tempoRestante =
      dataFim.getTime() -
      agora.getTime();

    // Janela já está fechada
    if (tempoRestante <= 0) {
      return;
    }

    // console.log(
    //   'Novo timer da janela 24h:',
    //   dataFim.toLocaleString(),
    //   'Tempo restante:',
    //   tempoRestante,
    //   'ms'
    // );

    // Agenda exatamente para o horário de fechamento
    this.timerJanela24h =
      setTimeout(() => {

        this.timerJanela24h = null;

        if (this.inputMensagemRef.current) {
          this.inputMensagemRef.current.blur();
        }

        this.setState({
          textoMensagem: '',
          arquivosImagem: [],
          previewsImagem: [],
          arquivoImagem: null,
          imagemSelecionada: null,
          previewImagem: null
        });

      }, tempoRestante);
  };

  scrollParaMensagem = async (idMensagem) => {

    let mensagemEncontrada =
      this.state.mensagens.find(
        mensagem =>
          Number(mensagem.id) === Number(idMensagem)
      );

    while (
      !mensagemEncontrada &&
      this.state.temMaisMensagens
    ) {

      const quantidadeAntes =
        this.state.mensagens.length;

      await this.carregarMensagensAnteriores();

      if (
        this.state.mensagens.length === quantidadeAntes
      ) {
        break;
      }

      mensagemEncontrada =
        this.state.mensagens.find(
          mensagem =>
            Number(mensagem.id) === Number(idMensagem)
        );
    }

    if (!mensagemEncontrada) {
      return;
    }

    const elemento =
      document.getElementById(
        `mensagem-chat-${idMensagem}`
      );

    const container =
      this.messagesAreaRef.current;

    if (!elemento || !container) {
      return;
    }

    const posicaoElemento =
      elemento.getBoundingClientRect().top -
      container.getBoundingClientRect().top +
      container.scrollTop;

    // Escurece a mensagem
    const filtroOriginal =
      elemento.style.filter;

    elemento.style.filter =
      'brightness(0.97)';

    // Faz o scroll
    container.scrollTo({
      top: posicaoElemento,
      behavior: 'smooth'
    });

    // Aguarda o scroll chegar na mensagem
    const verificarScroll = () => {

      const distancia =
        Math.abs(
          container.scrollTop -
          posicaoElemento
        );

      if (distancia <= 1) {

        // Aguarda 0,1 segundo após chegar
        setTimeout(() => {

          elemento.style.filter =
            filtroOriginal;

        }, 200);

        return;
      }

      requestAnimationFrame(verificarScroll);
    };

    requestAnimationFrame(verificarScroll);
  };

  render() {
    const { classes } = this.props;
    const {
      chats,
      chatSelecionado,
      mensagens,
      carregandoMensagens,
      textoMensagem,
      enviandoMensagem,
      textoPesquisa
    } = this.state;

    const chatsFiltrados = chats;

    const janela24hAberta =
      chatSelecionado &&
      chatSelecionado.datahorafimjanela &&
      new Date(chatSelecionado.datahorafimjanela) > new Date();

    return (
      <div className={classes.root}>

        {this.state.conversasExpandidas && (
          <div className={classes.overlayConversas} />
        )}

        {/* =====================================================
            LISTA DE CONVERSAS
            ===================================================== */}

        <div
          className={`${classes.conversations} ${this.state.conversasExpandidas
            ? classes.conversasExpandidas
            : ''
            }`}
        >

          {!this.state.conversasExpandidas && (
            <IconButton
              className={classes.botaoConversasRecolhido}
              onClick={this.alternarConversas}
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          )}

          <div
            className={`${classes.conversationsHeader} ${this.state.conversasExpandidas
              ? classes.conversationsHeaderExpandido
              : ''
              }`}
          >

            <div className={classes.conversationsHeaderTitulo}>

              <Typography variant="h6">
                Conversas
              </Typography>

              {this.state.conversasExpandidas && (
                <IconButton
                  className={classes.botaoConversas}
                  onClick={this.alternarConversas}
                >
                  <KeyboardArrowLeftIcon />
                </IconButton>
              )}

            </div>

            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Pesquisar"
              margin="normal"
              value={this.state.textoPesquisa}
              onChange={(event) => {

                const texto =
                  event.target.value;

                this.setState({
                  textoPesquisa: texto
                });

                clearTimeout(this.timerPesquisa);

                this.timerPesquisa = setTimeout(() => {

                  // console.log(
                  //   'Executando pesquisa:',
                  //   this.state.textoPesquisa
                  // );

                  this.loadChats();

                }, 400);

              }}
            />

          </div>

          <Divider
            className={`${classes.conversationsDivider} ${this.state.conversasExpandidas
              ? classes.conversationsDividerExpandido
              : ''
              }`}
          />

          <List
            className={classes.conversationsList}
            onScroll={(event) => {

              const {
                scrollTop,
                scrollHeight,
                clientHeight
              } = event.currentTarget;

              /*
               * Quando estiver próximo do final
               * da lista, carrega mais conversas.
               */
              if (
                scrollTop + clientHeight >=
                scrollHeight - 50
              ) {
                this.carregarChatsAnteriores();
              }

            }}
          >

            {chatsFiltrados.map((chat) => (

              <ListItem
                button
                key={chat.id}
                className={classes.conversationItem}
                selected={
                  chatSelecionado &&
                  chatSelecionado.id === chat.id
                }
                onClick={() => {
                  this.selecionarChat(chat);

                  if (
                    this.state.conversasExpandidas &&
                    window.innerWidth <= 599
                  ) {
                    this.alternarConversas();
                  }

                  setTimeout(() => {

                    if (
                      this.inputMensagemRef.current &&
                      chat.datahorafimjanela &&
                      new Date(chat.datahorafimjanela) > new Date()
                    ) {

                      this.inputMensagemRef.current.focus();

                      const input =
                        this.inputMensagemRef.current;

                      const tamanho =
                        input.value.length;

                      input.setSelectionRange(
                        tamanho,
                        tamanho
                      );
                    }

                  }, 0);
                }}
              >

                <div className={classes.conversationContent}>

                  {!this.state.conversasExpandidas && (
                    <div className={classes.iniciaisContato}>
                      {this.obterIniciaisContato(chat.nomecontato)}
                    </div>
                  )}

                  <ListItemText
                    className={`${classes.conversationText} ${this.state.conversasExpandidas
                      ? classes.conversationTextExpandida
                      : ''
                      }`}
                    primary={chat.nomecontato || chat.fone}
                    secondary={this.renderUltimaMensagem(chat.ultimamensagem)}
                    primaryTypographyProps={{
                      noWrap: true,
                      style: {
                        fontSize: 15
                      }
                    }}
                    secondaryTypographyProps={{
                      noWrap: true
                    }}
                  />

                  <div className={classes.conversationInfo}>

                    {chat.datahoraultimamsg && (
                      <span className={classes.conversationTime}>
                        {this.formatarDataLista(chat.datahoraultimamsg)}
                      </span>
                    )}

                    {chat.qtdemsgnaolidas > 0 && (
                      <div className={classes.unreadBadge}>
                        {chat.qtdemsgnaolidas > 99
                          ? '99+'
                          : chat.qtdemsgnaolidas}
                      </div>
                    )}

                  </div>

                </div>

              </ListItem>

            ))}

          </List>

        </div>


        {/* =====================================================
            CHAT
            ===================================================== */}

        <div
          className={`${classes.chatContainer} ${this.state.conversasExpandidas
            ? classes.chatContainerConversasExpandidas
            : ''
            }`}
          onClick={() => {
            if (this.state.conversasExpandidas && window.innerWidth <= 599) {
              this.alternarConversas();
            }
          }}
        >

          <div className={classes.chatHeader}>

            {chatSelecionado ? (

              <div className={classes.chatHeaderContent}>

                {chatSelecionado.nomecontato ? (
                  <>
                    <Typography
                      variant="h6"
                      className={classes.chatHeaderName}
                    >
                      {chatSelecionado.nomecontato}
                    </Typography>

                    <Typography
                      className={classes.chatHeaderPhone}
                    >
                      • {chatSelecionado.fone}
                    </Typography>
                  </>
                ) : (

                  <Typography variant="h6">
                    {chatSelecionado.fone}
                  </Typography>

                )}

              </div>

            ) : (

              <Typography variant="h6">
                Selecione uma conversa
              </Typography>

            )}

          </div>

          <div
            className={classes.messagesArea}
            ref={this.messagesAreaRef}
            onScroll={this.handleScrollMensagens}
          >

            {!chatSelecionado && (
              <Typography
                color="textSecondary"
                align="center"
              >
                Selecione uma conversa para visualizar as mensagens.
              </Typography>
            )}

            {chatSelecionado && carregandoMensagens && (
              <Typography
                color="textSecondary"
                align="center"
              >
                Carregando mensagens...
              </Typography>
            )}

            {chatSelecionado &&
              !carregandoMensagens &&
              mensagens.length === 0 && (
                <Typography
                  color="textSecondary"
                  align="center"
                >
                  Nenhuma mensagem encontrada.
                </Typography>
              )}

            {chatSelecionado &&
              !carregandoMensagens &&
              mensagens.map((mensagem, indice) => {

                const enviada = mensagem.direcao === DIRECAO_MSG_CHAT_ENVIADA;
                const mostrarData = this.deveMostrarData(mensagem, indice);

                return (
                  <React.Fragment key={mensagem.id}>

                    {/* =====================================================
                        DIVISOR DE DATA
                        ===================================================== */}
                    {mostrarData && (
                      <div className={classes.messageDate}>
                        <span className={classes.messageDateText}>
                          {this.formatarDataMensagem(mensagem.datahoramsg)}
                        </span>
                      </div>
                    )}

                    {/* =====================================================
                        MENSAGEM
                        ===================================================== */}
                    <div
                      id={`mensagem-chat-${mensagem.id}`}
                      className={
                        enviada
                          ? classes.messageSent
                          : classes.messageReceived
                      }
                    >

                      <div
                        className={
                          enviada
                            ? classes.messageBubbleSent
                            : classes.messageBubble
                        }
                      >

                        {/* =====================================================
                            TEXTO
                            ===================================================== */}
                        {mensagem.mensagemrespondida && (
                          <div
                            onClick={() =>
                              this.scrollParaMensagem(
                                mensagem.mensagemrespondida.id
                              )
                            }
                            style={{
                              borderLeft: '4px solid #25D366',
                              backgroundColor: '#f5f5f5',
                              padding: '6px 8px',
                              marginBottom: 6,
                              borderRadius: 4,
                              cursor: 'pointer'
                            }}
                          >
                            <Typography
                              variant="caption"
                              style={{
                                fontWeight: 600,
                                color: '#128C7E'
                              }}
                            >
                              {mensagem.mensagemrespondida.direcao === DIRECAO_MSG_CHAT_ENVIADA
                                ? 'Você'
                                : mensagem.nomecontato}
                            </Typography>

                            <Typography
                              variant="body2"
                              style={{
                                color: '#555'
                              }}
                            >
                              {this.formatarTextoWhatsApp(
                                mensagem.mensagemrespondida.texto
                              )}
                            </Typography>
                          </div>
                        )}

                        {mensagem.tipo === TIPO_MSG_CHAT_TEXTO && (
                          <div>
                            <Typography
                              component="span"
                              className={classes.messageText}
                            >
                              {this.formatarTextoWhatsApp(mensagem.texto)}
                            </Typography>

                            {this.renderHorarioStatus(mensagem)}

                            <div style={{ clear: 'both' }} />
                          </div>
                        )}

                        {mensagem.botoes && (
                          <div
                            style={{
                              marginTop: 8,
                              borderTop: '1px solid #e0e0e0'
                            }}
                          >
                            {JSON.parse(mensagem.botoes).map((botao, index) => (
                              <div
                                key={index}
                                style={{
                                  padding: '7px 12px',
                                  borderTop: index > 0
                                    ? '1px solid #e0e0e0'
                                    : 'none',
                                  textAlign: 'center',
                                  cursor: 'default'
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  style={{
                                    color: '#008069',
                                    fontWeight: 500
                                  }}
                                >
                                  {botao}
                                </Typography>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* =====================================================
                            IMAGEM
                            ===================================================== */}
                        {mensagem.tipo === TIPO_MSG_CHAT_IMAGEM && (
                          <div>

                            <div
                              className={`${classes.imagemContainer} ${classes.imagemContainerHover}`}
                              style={{
                                cursor: mensagem.urlmidia ? 'pointer' : 'default'
                              }}
                              onClick={() => {
                                if (mensagem.urlmidia) {
                                  this.abrirImagem(mensagem.urlmidia);
                                }
                              }}
                            >

                              {!mensagem.urlmidia && (
                                <CircularProgress
                                  size={30}
                                  style={{ color: '#aaa' }}
                                />
                              )}

                              {mensagem.urlmidia &&
                                !this.state.imagensCarregadas[mensagem.id] && (
                                  <CircularProgress
                                    size={30}
                                    style={{ color: '#aaa' }}
                                  />
                                )}

                              {mensagem.urlmidia && (
                                <img
                                  src={mensagem.urlmidia}
                                  alt=""
                                  onLoad={() => {
                                    this.imagemCarregada(mensagem.id);
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    display:
                                      this.state.imagensCarregadas[mensagem.id]
                                        ? 'block'
                                        : 'none'
                                  }}
                                />
                              )}

                              {mensagem.urlmidia && (
                                <div className={classes.imagemMenuArea}>

                                  <IconButton
                                    className={classes.imagemMenuBotao}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      this.abrirMenuImagem(event, mensagem);
                                    }}
                                    style={{
                                      position: 'absolute',
                                      top: -2,
                                      right: 0,
                                      width: 28,
                                      height: 28,
                                      padding: 0,
                                      color: '#fff',
                                      backgroundColor: 'transparent',
                                      boxShadow: 'none',
                                      pointerEvents: 'auto'
                                    }}
                                  >
                                    <KeyboardArrowDownIcon />
                                  </IconButton>

                                </div>
                              )}

                            </div>

                            {mensagem.texto && (
                              <div>
                                <Typography
                                  component="span"
                                  className={classes.messageText}
                                >
                                  {this.formatarTextoWhatsApp(mensagem.texto)}
                                </Typography>

                                {this.renderHorarioStatus(mensagem)}

                                <div style={{ clear: 'both' }} />
                              </div>
                            )}

                            {!mensagem.texto && (
                              <div style={{ textAlign: 'right' }}>
                                {this.renderHorarioStatus(mensagem)}
                              </div>
                            )}

                          </div>
                        )}

                        {/* =====================================================
                            DOCUMENTO
                            ===================================================== */}
                        {mensagem.tipo === TIPO_MSG_CHAT_DOCUMENTO && (
                          <div>

                            <Typography>
                              {mensagem.nomearquivo || 'Documento'}
                            </Typography>

                            {mensagem.texto && (
                              <div>
                                <Typography
                                  component="span"
                                  className={classes.messageText}
                                >
                                  {this.formatarTextoWhatsApp(mensagem.texto)}
                                </Typography>

                                {this.renderHorarioStatus(mensagem)}

                                <div style={{ clear: 'both' }} />
                              </div>
                            )}

                            {!mensagem.texto && (
                              <div style={{ textAlign: 'right' }}>
                                {this.renderHorarioStatus(mensagem)}
                              </div>
                            )}

                          </div>
                        )}

                      </div>

                    </div>

                  </React.Fragment>
                );
              })}

          </div>

          {this.state.mostrarSetaFinal && (
            <div
              style={{
                position: 'absolute',
                bottom: this.state.alturaInputArea + 10,
                right: 30,
                zIndex: 20,
                pointerEvents: 'none'
              }}
            >
              <div style={{ position: 'relative' }}>

                <IconButton
                  style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.90)',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
                    pointerEvents: 'auto'
                  }}
                  onClick={this.scrollToBottom}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>

                {this.state.chatSelecionado?.qtdemsgnaolidas > 0 && (
                  <div
                    className={classes.unreadBadge}
                    style={{
                      position: 'absolute',
                      top: -5,
                      right: -5
                    }}
                  >
                    {this.state.chatSelecionado.qtdemsgnaolidas > 99
                      ? '99+'
                      : this.state.chatSelecionado.qtdemsgnaolidas}
                  </div>
                )}

              </div>
            </div>
          )}

          <div
            ref={this.inputAreaRef}
            className={classes.inputArea}
            style={{
              pointerEvents:
                !chatSelecionado || !janela24hAberta
                  ? 'none'
                  : 'auto',
              opacity:
                !chatSelecionado || !janela24hAberta
                  ? 0.6
                  : 1
            }}
          >

            <div style={{
              width: '100%'
            }}>

              {this.state.previewsImagem.length > 0 && (

                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 8,
                    marginBottom: 8
                  }}
                >

                  {this.state.previewsImagem.map(
                    (preview, index) => (

                      <div
                        key={index}
                        style={{
                          position: 'relative',
                          display: 'inline-block',
                          padding: 4,
                          borderRadius: 10,
                          backgroundColor: '#f0f0f0'
                        }}
                      >

                        <img
                          src={preview}
                          alt={`Prévia ${index + 1}`}
                          style={{
                            width: 100,
                            height: 100,
                            objectFit: 'cover',
                            borderRadius: 8,
                            display: 'block'
                          }}
                        />

                        <IconButton
                          size="small"
                          onClick={() => this.removerImagem(index)}
                          disabled={enviandoMensagem}
                          style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            width: 24,
                            height: 24,
                            padding: 0,
                            backgroundColor: '#555',
                            color: '#fff',
                            border: '2px solid #fff',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                          }}
                        >
                          <span
                            style={{
                              fontSize: 18,
                              lineHeight: 1,
                              fontWeight: 'bold'
                            }}
                          >
                            ×
                          </span>
                        </IconButton>

                      </div>

                    )
                  )}

                </div>

              )}

              <div style={{
                display: 'flex',
                alignItems: 'center'
              }}>

                <input
                  ref={this.inputImagemRef}
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: 'none' }}
                  onChange={this.selecionarImagem}
                />

                <IconButton
                  disabled={!chatSelecionado || enviandoMensagem}
                  onClick={() => {
                    this.inputImagemRef.current.click();
                  }}
                  style={{
                    marginRight: 8,
                    width: 38,
                    height: 38
                  }}
                >
                  <ImageIcon />
                </IconButton>

                <TextField
                  inputRef={this.inputMensagemRef}
                  fullWidth
                  variant="outlined"
                  placeholder={
                    !chatSelecionado
                      ? "Selecione uma conversa..."
                      : !janela24hAberta
                        ? "Janela de envio fechada."
                        : "Digite uma mensagem..."
                  }
                  size="small"
                  multiline
                  maxRows={5}
                  disabled={
                    !chatSelecionado ||
                    enviandoMensagem
                  }
                  InputProps={{
                    classes: {
                      input: !janela24hAberta && chatSelecionado
                        ? classes.inputJanelaFechada
                        : undefined
                    }
                  }}
                  value={textoMensagem}
                  onChange={(event) => {
                    this.setState({
                      textoMensagem: event.target.value
                    });
                  }}
                  onKeyDown={(event) => {

                    if (
                      event.key === 'Enter' &&
                      !event.shiftKey
                    ) {
                      event.preventDefault();
                      this.enviarMensagem();
                    }

                  }}
                />

                <IconButton
                  disabled={
                    !chatSelecionado ||
                    enviandoMensagem ||
                    (
                      !textoMensagem.trim() &&
                      !this.state.arquivosImagem.length
                    )
                  }
                  onClick={this.enviarMensagem}
                  style={{
                    marginLeft: 8,
                    width: 38,
                    height: 38,
                    backgroundColor:
                      !chatSelecionado ||
                        enviandoMensagem ||
                        (
                          !textoMensagem.trim() &&
                          !this.state.arquivosImagem.length
                        )
                        ? '#d5d5d5'
                        : '#25D366',
                    color: '#fff',
                    alignSelf: 'center',
                    marginTop: 0
                  }}
                >
                  <SendIcon />
                </IconButton>

              </div>

            </div>

          </div>

        </div>

        <Menu
          anchorEl={this.state.menuImagemAnchor}
          open={Boolean(this.state.menuImagemAnchor)}
          onClose={this.fecharMenuImagem}
          getContentAnchorEl={null}

          anchorOrigin={{
            vertical: 'bottom',
            horizontal: this.state.menuImagemAbrirDireita
              ? 'left'
              : 'right'
          }}

          transformOrigin={{
            vertical: 'top',
            horizontal: this.state.menuImagemAbrirDireita
              ? 'left'
              : 'right'
          }}

          PaperProps={{
            style: {
              borderRadius: 5,
              minWidth: 100,
              boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
              marginTop: 0
            }
          }}
        >
          <MenuItem
            onClick={() => {

              const mensagem = this.state.menuImagem;

              this.fecharMenuImagem();

              if (mensagem) {
                this.baixarImagem(mensagem);
              }

            }}
            style={{
              minHeight: 30,
              height: 30,
              padding: '4px 10px',
              fontSize: 13
            }}
          >
            <GetAppIcon
              style={{
                fontSize: 17,
                marginRight: 7,
                color: '#555'
              }}
            />
            Baixar
          </MenuItem>
        </Menu>

        <Dialog
          open={!!this.state.imagemSelecionada}
          onClose={this.fecharImagem}
          maxWidth={false}
        >
          <img
            src={this.state.imagemSelecionada}
            alt="Imagem"
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              display: 'block'
            }}
          />
        </Dialog>

      </div>
    );
  }
}

export default withStyles(styles)(WhatsAppChat);